import { IReduxStore } from "Redux/Store/IReduxStore";

export const getLastOrder = (state: IReduxStore) => state.persist.lastOrder;
